module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Trend2_16"],"path":[{"$":{"d":"M1,15H16v1H0V2H1ZM14.62,7,12,1.76,8.38,9H5.46l-2,3H2v2H4.54l2-3H9.62L12,6.24,13.38,9H16V7Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Trend2_16.svg
// module id = ch5b
// module chunks = 1